<form
  #form="ngForm"
  novalidate
>
  <h1 class="mb-4 justify-self-center text-xl">Fuel Specifications</h1>

  <re-fuel-specs-table
    data-ping-host
    [rows]="rows"
    [data]="consumptionsStore.fuelSpecsTableVm()"
    [fuelTypeOptionsByRow]="fuelTypeOptionsByRow"
    (fuelTypeChanged)="fuelTypeChanged($event)"
    (fuelISOGradeChanged)="onFuelISOGradeChange($event)"
    (rangeStatusChanged)="onRangeStatusChanged($event)"
    (entryRemoved)="removeEntry($event)"
    (entryAdded)="addEntry()"
  ></re-fuel-specs-table>
</form>
